import type { SkuSpecification } from '../types/product'

interface ProductQuantitySKUV3Props {
  SkuSpecification: SkuSpecification[]
}

export default function ProductQuantitySKUV3({
  SkuSpecification,
}: ProductQuantitySKUV3Props) {
  const titleSku = 'cores'

  return (
    <span className="font-inter text-[12px] text-tertiary font-regular leading-5">
      {`${SkuSpecification[0]?.values?.length} ${titleSku}`}
    </span>
  )
}
